import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React, { useCallback } from 'react';
import classnames from 'classnames';
import styles from './button.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Button = function Button(_ref) {
  var _classnames3;

  var className = _ref.className,
      id = _ref.id,
      title = _ref.title,
      icon = _ref.icon,
      refElem = _ref.refElem,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? 'left' : _ref$order,
      primary = _ref.primary,
      light = _ref.light,
      dark = _ref.dark,
      danger = _ref.danger,
      quiet = _ref.quiet,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      transparent = _ref.transparent,
      stroke = _ref.stroke,
      radius = _ref.radius,
      large = _ref.large,
      medium = _ref.medium,
      small = _ref.small,
      _long = _ref["long"],
      onClick = _ref.onClick,
      _ref$tabindex = _ref.tabindex,
      tabindex = _ref$tabindex === void 0 ? 0 : _ref$tabindex,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      href = _ref.href,
      _ref$newTab = _ref.newTab,
      newTab = _ref$newTab === void 0 ? false : _ref$newTab;
  var fakeFn = useCallback(function () {}, []);
  var preventFn = useCallback(function (e) {
    return e.preventDefault();
  }, []);

  if (type === 'a') {
    var _classnames;

    return /*#__PURE__*/_jsxs("a", {
      ref: refElem,
      id: id,
      href: href,
      target: newTab ? '_blank' : '',
      onClick: disabled ? preventFn : onClick || fakeFn,
      className: classnames(className, styles.button, (_classnames = {}, _defineProperty(_classnames, styles.disabled, disabled), _defineProperty(_classnames, styles.stroke, stroke), _defineProperty(_classnames, styles.radius1, radius === 1), _defineProperty(_classnames, styles.radius2, radius === 2 || !radius), _defineProperty(_classnames, styles.radius3, radius === 3), _defineProperty(_classnames, styles.primary, primary || !light && !dark), _defineProperty(_classnames, styles.light, light), _defineProperty(_classnames, styles.dark, dark), _defineProperty(_classnames, styles.danger, danger), _defineProperty(_classnames, styles.transparent, transparent), _defineProperty(_classnames, styles.quiet, quiet), _defineProperty(_classnames, styles.large, large || !small && !medium), _defineProperty(_classnames, styles.medium, medium), _defineProperty(_classnames, styles.small, small), _classnames)),
      rel: "noreferrer",
      children: [icon && /*#__PURE__*/_jsx("span", {
        className: classnames(styles.icon, _defineProperty({}, styles.withTitle, !!title)),
        children: icon
      }), title && /*#__PURE__*/_jsx("p", {
        className: styles.title,
        children: title
      })]
    });
  }

  return /*#__PURE__*/_jsxs("button", {
    // eslint-disable-next-line react/button-has-type
    type: type,
    id: id,
    ref: refElem,
    disabled: disabled,
    tabIndex: tabindex,
    onClick: onClick || fakeFn,
    className: classnames(className, styles.button, (_classnames3 = {}, _defineProperty(_classnames3, styles.disabled, disabled), _defineProperty(_classnames3, styles.stroke, stroke), _defineProperty(_classnames3, styles.radius1, radius === 1), _defineProperty(_classnames3, styles.radius2, radius === 2 || !radius), _defineProperty(_classnames3, styles.radius3, radius === 3), _defineProperty(_classnames3, styles.primary, primary || !light && !dark && !quiet), _defineProperty(_classnames3, styles.light, light), _defineProperty(_classnames3, styles.dark, dark), _defineProperty(_classnames3, styles.danger, danger), _defineProperty(_classnames3, styles.transparent, transparent), _defineProperty(_classnames3, styles.quiet, quiet), _defineProperty(_classnames3, styles.large, large || !small && !medium), _defineProperty(_classnames3, styles.medium, medium), _defineProperty(_classnames3, styles["long"], _long), _defineProperty(_classnames3, styles.small, small), _classnames3)),
    children: [order === 'left' && icon && /*#__PURE__*/_jsx("span", {
      className: classnames(styles.icon, _defineProperty({}, styles.withTitle, !!title)),
      children: icon
    }), title && /*#__PURE__*/_jsx("p", {
      className: styles.title,
      children: title
    }), order === 'right' && icon && /*#__PURE__*/_jsx("span", {
      className: classnames(styles.iconRight, _defineProperty({}, styles.withTitle, !!title)),
      children: icon
    })]
  });
};